
export const pluralWords = Object.freeze({
  // card types
  STAFF: "Staff",
  ENTRY: "Entries",
});

export const singleWords = Object.freeze({
  // card types
  STAFF: "Staff",
  ENTRY: "Entry",
}); 

// Function to get region-specific expense header
export const getRegionSpecificExpenseHeader = (region: string): string => {
  switch (region) {
    case "AU":
      return "Unbilled Disbursements";
    case "GB":
      return "Unbilled Cost Recoveries";
    case "US":
      return "Unbilled Expenses";
    default:
      return "Unbilled Expenses"; // default to US if region is not recognised
  }
};

// Function to get region-specific expense label
export const getRegionSpecificExpenseLabel = (region: string): string => {
  switch (region) {
    case "AU":
      return "Disbursement";
    case "GB":
      return "Cost Recovery";
    case "US":
      return "Expense";
    default:
      return "Expense"; // default to US if region is not recognised
  }
};

// Function to get region-specific data selection modal time, fee, and disb label
export const getTimeFeesDisbursementsRegionSpecificLabel = (region: string) => {
  switch (region) {
    case "AU":
      return "Unbilled Time, Fees, and Disbursements";
    case "US":
      return "Unbilled Time, Fees, and Expenses";
    case "GB":
      return "Unbilled Time, Fees, and Cost Recoveries";
    default:
      return "Unbilled Time, Fees, and Expenses"; // Default to US wording
  }
};

// Function to get region-specific data selection opening balances description
export const getOpeningBalancesSpecificDescription = (region: string) => {
  switch (region) {
    case "AU":
      return "Matter Credit and Trust balances";
    case "US":
      return "Matter Operating, Credit, and Trust balances";
    case "GB":
      return "Matter Credit and Client account balances";
    default:
      return "Matter Operating, Credit, and Trust balances";
  }
};

// Function to get region-specific data selection invoices - basic description
export const getInvoicesBasicSpecificDescription = (region: string) => {
  switch (region) {
    case "AU":
      return "Creates one summary Fee and/or Disbursement line item per Invoice based on the totals provided";
    case "US":
      return "Creates one summary Fee and/or Expense line item per Invoice based on the totals provided";
    case "GB":
      return "Creates one summary Fee and/or Cost Recovery line item per Invoice based on the totals provided";
    default:
      return "Creates one summary Fee and/or Expense line item per Invoice based on the totals provided";;
  }
};

// Function to get region-specific data selection invoices - detailed description
export const getInvoicesDetailedSpecificDescription = (region: string) => {
  switch (region) {
    case "AU":
      return "Allows one or more detailed Fee/Disbursement line items per invoice";
    case "US":
      return "Allows one or more detailed Fee/Expense line items per invoice";
    case "GB":
      return "Allows one or more detailed Fee/Cost Recovery line items per invoice";
    default:
      return "Allows one or more detailed Fee/Expense line items per invoice";
  }
};


export const PRODUCT_TIERS = Object.freeze({
  BILL: "SMK001",
  BOOST: "SMK004",
  GROW: "SMK002",
  PROSPER: "SMK003",
});